import {
  Button,
  Checkbox,
  Container,
  Paper,
  PasswordInput,
  Text,
  TextInput,
} from '@mantine/core'
import { useNavigate } from 'react-router-dom'
import { useForm, zodResolver } from '@mantine/form'
import { emptyLoginSchema, LoginForm, LoginFormSchema } from '../models/user'
import { useLogin } from '../api/user'

export default function LoginPage() {
  const form = useForm<LoginForm>({
    initialValues: emptyLoginSchema,
    validate: zodResolver(LoginFormSchema),
  })
  const navigate = useNavigate()
  const { mutate: login, isPending, isError, error } = useLogin()

  const handleLogin = (data: LoginForm) => {
    login(data, {
      onSuccess: (data, variables) => {
        if (data.marinas.length > 0) {
          navigate(`/marina/${data.marinas[0].marina_id}`)
        } else {
          navigate('/')
        }
      },
    })
  }

  return (
    <Container size={500} mt={50}>
      <Paper withBorder shadow="md" p={30} mt={5} radius="md">
        <form onSubmit={form.onSubmit((values) => handleLogin(values))}>
          <TextInput
            label="Username"
            placeholder="Username"
            required
            radius="lg"
            {...form.getInputProps('username')}
          />
          <PasswordInput
            label="Password"
            placeholder="Password"
            required
            radius="lg"
            mt="md"
            {...form.getInputProps('password')}
          />
          <Checkbox label="Remember me" mt="md" />
          {isError && (
            <Text c="red" size="xs" mt={5}>
              {error.message}
            </Text>
          )}
          <Button
            disabled={isPending}
            loading={isPending}
            radius="md"
            fullWidth
            mt="md"
            type="submit"
          >
            Sign in
          </Button>
        </form>
      </Paper>
    </Container>
  )
}
